import { useAppSelector } from 'root/src/client/logic/helpers/useStore';
export function useAccountData() {
    return useAppSelector(state => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.accountData; });
}
